// extracted by mini-css-extract-plugin
export default {"mainBlock":"SteamCardsPage_mainBlock__hkD9D","footer":"SteamCardsPage_footer__dubX8"};